import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {


  pageindex: any = -1;

  urlname: any = "";

  companyBO: any = {}
  questionColl: any = [];

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  feedbackform = new FormGroup({
    customername: new FormControl(null, Validators.required),
    mobile: new FormControl(null, [
      Validators.required,
      Validators.pattern("^[0-9]{10}$")
    ]),
    remarks: new FormControl(null),
  });

  routerEventSubscription = Subscription.EMPTY;
  constructor(public loginService: LoginDataService, public router: Router, private appService: DhukanDataService, private cuurenctRoute: ActivatedRoute) {
    this.routerEventSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe(() => {
        this.fnGetUrlParameters()
      });
  }

  ngOnInit() {
    this.feedbackform.reset();
    this.fnInitializeQuestion();
  }


  fnInitializeQuestion() {
    this.feedbackform.setValue({
      customername: null,
      mobile: null,
      remarks: null,
    })
  }


  ngOnDestroy(): void {
    if (this.routerEventSubscription !== undefined) {
      this.routerEventSubscription.unsubscribe();
    }
  }


  fnGetUrlParameters() {
    this.urlname = this.cuurenctRoute.snapshot.paramMap.get('urlname');

    if (this.urlname !== "") {
      this.fnGetQuestionDetails();
    }
  }

  fnGetQuestionDetails() {
    var data = {
      'urlname': this.urlname,
    }
    this.appService.getQuestionDetailsFeedback(data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {
            var result = res.json().result;
            console.log(result)

            if (result.length > 0) {
              if (result[0].length > 0) {
                this.companyBO = result[0][0]
                this.questionColl = result[1]
                this.pageindex = 1
              }
              else {
                this.pageindex = 3
              }

            }

          }
          else if (res.json().status == 400) {
            // this.toastr.error('Error', res.json().err_field);
          }
        },
        (err) => {
          //this.toastr.error('Error', err);
        })
  }


  fnSubmitBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.feedbackform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'customername': this.feedbackform.get('customername').value,
          'mobile': this.feedbackform.get('mobile').value,
          'remarks': this.feedbackform.get('remarks').value,
          'companyid': this.companyBO.companyid,
          'questioncoll': this.questionColl
        }

        this.appService.fnInsertfeedback(data).subscribe(
          (res) => {
            if (res.json().status == 200) {
              this.pageindex = 2
            }
          },
          (err) => {
            this.saveloading = false;
          });
      }
    } catch (ex) {
      this.saveloading = false;
    }
  }



  fnStarClick(index, value) {
    this.questionColl[index].feedbackvalue = value;
  }

}
